import { render, staticRenderFns } from "./Testing.vue?vue&type=template&id=00495382&scoped=true"
import script from "./Testing.vue?vue&type=script&lang=js"
export * from "./Testing.vue?vue&type=script&lang=js"
import style0 from "./Testing.vue?vue&type=style&index=0&id=00495382&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00495382",
  null
  
)

export default component.exports